"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var dateContainer_1 = __importDefault(require("./dateContainer"));
require("./style.sass");
var UserContainer_1 = __importDefault(require("./UserContainer"));
function NavBar() {
    return (react_1.default.createElement("div", { className: 'navbar' },
        react_1.default.createElement(dateContainer_1.default, null),
        react_1.default.createElement("div", { style: {
                display: 'flex',
                alignItems: 'center',
                marginRight: 15,
            } },
            react_1.default.createElement(UserContainer_1.default, null))));
}
exports.default = NavBar;
